import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

const inputCls = "w-full rounded-lg bg-white px-3 py-2 font-body text-sm outline-none border";
const inputStyle = { borderColor: "rgba(11,27,61,0.2)", color: "var(--navy)" };

export const SendVideoCell = ({ row, token, fmtDate, onSent }) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState(row.video_url || "");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const tid = `${row.source_type}-${row.id}`;

  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post("/admin/video-requests/deliver",
        { id: row.id, source_type: row.source_type, video_url: url, message },
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`Video sent to ${row.email}`);
      onSent(row, data.delivered_at, url);
      setOpen(false);
    } catch (err) {
      toast.error(err.response?.status === 502 ? "Email could not be delivered to this address yet." : "Could not send. Check the link and try again.");
    } finally {
      setSending(false);
    }
  };

  if (!open) {
    return (
      <div className="flex flex-col gap-2 items-start">
        {row.delivered_at && (
          <span className="inline-flex items-center gap-1 text-xs whitespace-nowrap" style={{ color: "#2E7D32" }} data-testid={`video-sent-badge-${tid}`}>
            <CheckCircle2 size={14} /> Sent {fmtDate(row.delivered_at)}
          </span>
        )}
        <button onClick={() => setOpen(true)} className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-body whitespace-nowrap text-white" style={{ backgroundColor: "var(--navy)" }} data-testid={`send-video-open-${tid}`}>
          <Send size={13} /> {row.delivered_at ? "Send again" : "Send video"}
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={send} className="flex flex-col gap-2 min-w-[260px]" data-testid={`send-video-form-${tid}`}>
      <input type="url" required placeholder="Paste video link (https://…)" value={url} onChange={(e) => setUrl(e.target.value)} className={inputCls} style={inputStyle} data-testid={`send-video-url-${tid}`} />
      <textarea rows={2} placeholder="Optional personal note" value={message} onChange={(e) => setMessage(e.target.value)} className={inputCls} style={inputStyle} data-testid={`send-video-note-${tid}`} />
      <div className="flex gap-2">
        <button type="submit" disabled={sending} className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs text-white" style={{ backgroundColor: "var(--navy)" }} data-testid={`send-video-submit-${tid}`}>
          {sending ? <Loader2 size={13} className="animate-spin" /> : <Send size={13} />} Email parent
        </button>
        <button type="button" onClick={() => setOpen(false)} className="px-4 py-2 rounded-full text-xs border" style={{ borderColor: "rgba(11,27,61,0.2)", color: "var(--navy)" }} data-testid={`send-video-cancel-${tid}`}>Cancel</button>
      </div>
    </form>
  );
};
